import React from 'react';

const RouteMap = ({ route, pets }) => {
  // En una implementación real usaríamos una librería de mapas como Google Maps
  // Esta es una representación simulada
  const stops = route.stops.map(stop => {
    const pet = pets.find(p => p.id === stop.petId);
    return {
      ...stop,
      ...pet
    };
  });

  return (
    <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
      <h3 className="text-lg font-semibold mb-4">Mapa de Ruta</h3>
      <div className="bg-gray-100 h-64 rounded-lg flex items-center justify-center">
        <div className="text-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
          </svg>
          <p className="mt-2 text-gray-500">Mapa interactivo con {stops.length} paradas</p>
          <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-2">
            {stops.map((stop, index) => (
              <div key={index} className="flex items-center">
                <div className={`w-3 h-3 rounded-full mr-2 ${
                  stop.action === 'pickup' ? 'bg-cyan-500' : 'bg-green-500'
                }`}></div>
                <span className="text-sm">
                  {index+1}. {stop.name} ({stop.action === 'pickup' ? 'Recogida' : 'Entrega'})
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RouteMap;